
(function() {
  requirejs.config({
    paths: {
      jquery: "../../../components/jquery/jquery",
      underscore: "../../../components/underscore/underscore",
      backbone: "../../../components/backbone/backbone",
      "backbone.router.flow": "../../../components/backbone.router.flow/backbone.router.flow"
    },
    shim: {
      backbone: {
        deps: ["underscore", "jquery"],
        exports: "Backbone"
      },
      "backbone.router.flow": {
        deps: ["backbone", "underscore"],
        exports: "Router"
      },
      underscore: {
        exports: "_"
      }
    }
  });

  require(["jquery", "backbone.router.flow", "app"], function($, App) {});

}).call(this);

define("bootstrap_build", function(){});
